<template>
    <router-view/>
</template>

<script lang="ts" setup>
  import { reactive, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import {getUserInfo} from '@/api/common';
  import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
  import { useAccountStore, useMenuStore, useSettingStore, storeToRefs } from '@/store';
  import avatar from '@/assets/avatar.png';
  // import { PageFooter, HeaderActions } from '@/components/layout';
  import { LoginModal } from '@/pages/login';
  import { configTheme, themeList } from '@/theme';
  // import { ThemeProvider } from 'stepin';
  import { computed } from 'vue';

console.log('init_app----------------')
</script>

<style lang="less">
  // .stepin-view {
  //   ::-webkit-scrollbar {
  //     width: 4px;
  //     height: 4px;
  //     border-radius: 4px;
  //     background-color: theme('colors.primary.500');
  //   }

  //   ::-webkit-scrollbar-thumb {
  //     border-radius: 4px;
  //     background-color: theme('colors.primary.400');

  //     &:hover {
  //       background-color: theme('colors.primary.500');
  //     }
  //   }

  //   ::-webkit-scrollbar-track {
  //     box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
  //     border-radius: 4px;
  //     background: theme('backgroundColor.layout');
  //   }
  // }

  // html {
  //   height: 100vh;
  //   overflow-y: hidden;
  // }

  // body {
  //   margin: 0;
  //   height: 100vh;
  //   overflow-y: hidden;
  // }
  // .stepin-img-checkbox {
  //   @apply transition-transform;
  //   &:hover {
  //     @apply scale-105 ~"-translate-y-[2px]";
  //   }
  //   img {
  //     @apply shadow-low rounded-md transition-transform;
  //   }
  // }
  // .ant-card-head, .ant-card-body{
  //   background-color:#FAFAFA!important;
  //   box-shadow: 
  //   inset 0 0 5px 2px #EFF8FB,
  //   inset 0 0 15px 5px #EFF8FB;
  // }
</style>
